export default __webpack_public_path__ + "static/media/call-phone.ea85ddb0.svg";